/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-20 17:54:18
 * @LastEditTime: 2020-12-04 10:02:38
 * @FilePath: \ensurance-front\src\utils\permission.js
 */
import router from '@/router'
import store from '@/store'

// 路由守卫
router.beforeEach((to, from, next) => {
  if (!to.path.startsWith('/login') && !store.getters.token) {
    // 定义一个需要跳转的路径 也需要获取当前要去的地址 用于登录成功后继续跳转到之前要去的地址
    // 地址也是？传参的形式放入地址 所以需要用query方法
    let toPath = {
      path: '/login'
      // query: { redirectUrl: to.path }
    }
    next(toPath)
  } else {
    // 直接放行
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/utils/permission.js